export function validateEmail(email: string) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

export function capitalizeFirstLetter(string: string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
export function safeJSONParse(jsonString: string) {
  try {
    return JSON.parse(jsonString);
  } catch (e) {
    return false;
  }
}
